import { Component } from '@angular/core';
import { ICellRendererParams } from "ag-grid-community";
import { Contact } from "@models/common/contact";
import { ICellRendererAngularComp } from "ag-grid-angular";
import {
  AgActionIconButtonComponent
} from "@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component";
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";

type IAgIndividualContactAction = (contact: Contact) => void
type IAgIndividualContactParams = ICellRendererParams<Contact> & {
  primaryContactId: string | null;
  onSetContactAsPrimary: IAgIndividualContactAction;
  onEditContact: IAgIndividualContactAction;
  onDeleteContact: IAgIndividualContactAction;
}

@Component({
  selector: 'app-ag-individual-contact-actions',
  standalone: true,
  imports: [
    AgActionIconButtonComponent,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle
  ],
  templateUrl: 'ag-individual-contact-actions.component.html',
  styleUrl: 'ag-individual-contact-actions.component.scss'
})
export class AgIndividualContactActionsComponent implements ICellRendererAngularComp {
  params: IAgIndividualContactParams | null = null;
  isPrimaryContact = false;

  agInit(params: IAgIndividualContactParams): void {
    this.updateCell(params);
  }

  refresh(params: IAgIndividualContactParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: IAgIndividualContactParams) {
    this.isPrimaryContact = Boolean(params.primaryContactId && params.primaryContactId == params.data?.contactId);
    this.params = params;
    return true;
  }

  onSetContactAsPrimary(): void {
    this.params?.onSetContactAsPrimary(this.params?.data!);
  }

  onEditContact(): void {
    this.params?.onEditContact(this.params?.data!);
  }

  onDeleteContact(): void {
    this.params?.onDeleteContact(this.params?.data!);
  }
}
